module.exports = __webpack_public_path__ + "static/media/zero.e4a40d3c.svg";